export default __webpack_public_path__ + "static/flutter_service_features-a7b487c4467b292761b5bbe742630643.svg";